var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4286 6.5H8.56339C7.14911 6.5 6 7.66518 6 9.09554V39.9045C6 41.3348 7.14911 42.5 8.56339 42.5H39.4286C40.8429 42.5 42 41.3348 42 39.9045V9.09554C42 7.66518 40.8429 6.5 39.4286 6.5ZM16.8804 37.3571H11.5446V20.1768H16.8884V37.3571H16.8804ZM14.2125 17.8304C12.5009 17.8304 11.1188 16.4402 11.1188 14.7366C11.1188 13.033 12.5009 11.6429 14.2125 11.6429C15.9161 11.6429 17.3062 13.033 17.3062 14.7366C17.3062 16.4482 15.9241 17.8304 14.2125 17.8304ZM36.8812 37.3571H31.5455V29C31.5455 27.0071 31.5054 24.4438 28.7732 24.4438C25.9929 24.4438 25.567 26.6134 25.567 28.8554V37.3571H20.2313V20.1768H25.35V22.5232H25.4223C26.1375 21.1732 27.8813 19.7509 30.4768 19.7509C35.8768 19.7509 36.8812 23.3107 36.8812 27.9393V37.3571Z",
    fill: "#2867B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/LINKEDIN.184fc41aed21f029da5c8ffe037d4f2f.svg";
export { ForwardRef as ReactComponent };